import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { eBusBangKiemTuanThuActionTypeIds, IBusBangKiemTuanThuActionTypes } from "../../action-types/bus/IBusBangKiemTuanThuActionTypes";
import { IBusBangKiemTuanThuPageStateModel } from "../../page-state-model/bus/IBusBangKiemTuanThuPageState";

const initialState: IBusBangKiemTuanThuPageStateModel = {
	status: ePageBaseStatus.is_not_initialization,
	bus_bangkiemtuanthus: [],
	bus_bangkiemtuanthu_editing: undefined,
	bus_bangkiemtuanthu_selected_ids: [],
	is_show_delete_confirm: false,
	is_show_detail_modal: false
}
export const busBangKiemTuanThuReducer = (state: IBusBangKiemTuanThuPageStateModel = initialState, action: IBusBangKiemTuanThuActionTypes): IBusBangKiemTuanThuPageStateModel => {
	switch (action.type) {
		case eBusBangKiemTuanThuActionTypeIds.LOAD_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading
			}
		case eBusBangKiemTuanThuActionTypeIds.LOAD_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				bus_bangkiemtuanthus: action.payload
			}
		case eBusBangKiemTuanThuActionTypeIds.LOAD_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				bus_bangkiemtuanthus: []
			}
		case eBusBangKiemTuanThuActionTypeIds.SHOW_DETAIL:
			return {
				...state,
				is_show_detail_modal: true,
				bus_bangkiemtuanthu_editing: action.payload
			}
		case eBusBangKiemTuanThuActionTypeIds.CLOSE_DETAIL:
			return {
				...state,
				is_show_detail_modal: false,
				bus_bangkiemtuanthu_editing: undefined
			}
		case eBusBangKiemTuanThuActionTypeIds.CHANGE_SELECTED_IDS:
			return {
				...state,
				bus_bangkiemtuanthu_selected_ids: action.payload
			}
		case eBusBangKiemTuanThuActionTypeIds.SHOW_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: true
			}
		case eBusBangKiemTuanThuActionTypeIds.CLOSE_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: false
			}
		case eBusBangKiemTuanThuActionTypeIds.DELETE_START:
			return {
				...state,
				status: ePageBaseStatus.is_deleting
			}
		case eBusBangKiemTuanThuActionTypeIds.DELETE_SUCCESS:
			NotifyHelper.Success("Xoá dữ liệu thành công.")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_delete_confirm: false
			}
		case eBusBangKiemTuanThuActionTypeIds.DELETE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				is_show_delete_confirm: false
			}
		case eBusBangKiemTuanThuActionTypeIds.SAVE_START:
			return {
				...state,
				status: ePageBaseStatus.is_saving
			}
		case eBusBangKiemTuanThuActionTypeIds.SAVE_SUCCESS:
			NotifyHelper.Success("Thay đổi dữ liệu thành công.")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_detail_modal: false,
				bus_bangkiemtuanthu_editing: undefined
			}
		case eBusBangKiemTuanThuActionTypeIds.SAVE_ERR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed
			}
		default:
			return state;
	}
}
